module.exports = __webpack_public_path__ + "3f16e137/img/comments-icon.fdec7fdb.svg";